import { FC, ReactElement, ReactNode } from 'react';

import { Token, TokenType } from './lib/lexer';
import { Amount, Hashtag, Mention, NewLine, TextString, UserTag } from './token-components';

export type DecorateSegment = (segment: ReactNode, type: TokenType) => ReactNode;

interface Props {
	decorateSegment?: DecorateSegment;
	token: Token;
}

const TokenMap: Partial<Record<TokenType, (text: string) => ReactElement>> = {
	[TokenType.AMOUNT]: (text: string) => Amount(text),
	[TokenType.HASHTAG]: (text: string) => Hashtag(text),
	[TokenType.MENTION]: (text: string) => Mention(text),
	[TokenType.TEXT]: (text: string) => TextString(text),
	[TokenType.USER_TAG]: (text: string) => UserTag(text),
	[TokenType.NEWLINE]: () => NewLine(),
};

const BonusTextSegment: FC<Props> = ({ decorateSegment, token: { kind, text } }) => {
	const result = TokenMap[kind]?.(text);
	return <>{decorateSegment?.(result, kind) || result}</>;
};

export default BonusTextSegment;
